import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { requerido } from './Validaciones'

import { cookieData } from '../funciones/ConsultaUser';

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la publicación. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.titulo, "", "", "", "El Título de la Publicación es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.quien.value, "", "", "", "Debes seleccionar Quién puede ver esta publicación", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                campos: campos,
                uId: cookie[1]
            }

            Post(`${Url}addPublicacion`, Content, (resp) => {
                let data = JSON.parse(resp);

                if (data.status === "NA") {
                    errores = 1;
                    mensaje = [{
                        status: "error",
                        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
                    }];
                    states.push({
                        status: "text-danger",
                        text: "Datos Duplicados"
                    })
                    nameErr.push(data.mess)
                }else{
                    mensaje = [{
                        status: "info",
                        mensaje: "Se ha guardado correctamente la publicación"
                    }];
                }

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const ConsultPublicaciones = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}consultPub`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/PublicacionesFunction.jsx